module.exports = __webpack_public_path__ + "img/51600.d7adaf7a.jpg";